import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { deleteCoreDataDictionaryViewsSharedKeyAsyncSlice } from './delete';
import { getCoreDataDictionaryViewsSharedKeyAsyncSlice } from './get';
import { postCoreDataDictionaryViewsSharedKeyAsyncSlice } from './post';

export const coreDataDictionaryViewsSharedKeyReducers = combineReducers({
	delete: deleteCoreDataDictionaryViewsSharedKeyAsyncSlice.asyncReducers,
	get: getCoreDataDictionaryViewsSharedKeyAsyncSlice.asyncReducers,
	post: postCoreDataDictionaryViewsSharedKeyAsyncSlice.asyncReducers
});

export const coreDataDictionaryViewsSharedKeyWatchers = combineAllWatchers([
	deleteCoreDataDictionaryViewsSharedKeyAsyncSlice.asyncWatchers,
	getCoreDataDictionaryViewsSharedKeyAsyncSlice.asyncWatchers,
	postCoreDataDictionaryViewsSharedKeyAsyncSlice.asyncWatchers
]);
